function Pricing() {
    return (
      <section id="pricing" className="section">
        <h2>Pricing Plans</h2>
  
        <div className="grid">
          <div className="card">Basic - ₹499</div>
          <div className="card">Standard - ₹999</div>
          <div className="card">Premium - ₹1499</div>
        </div>
      </section>
    );
  }
  
  export default Pricing;